import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { NotifyAskModal } from '../mySelection/NotifyAskModal';
import { getPushPermissionState } from '../../services/pushService';
import { SEL_API } from '../../lib/selectionShare';

// Right after a selection is saved: "Vuoi essere avvisato su questa selezione?" (alerts stay off unless Sì)
export const SaveNotifyAsk = ({ selectionId, onDone }) => {
  const [pushState, setPushState] = useState(null);

  useEffect(() => {
    getPushPermissionState().catch(() => 'unsupported').then((s) => {
      if (s === 'granted' || s === 'prompt') setPushState(s);
      else onDone?.(false); // notifications blocked on this device: nothing to ask
    });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const answer = async (yes) => {
    setPushState(null);
    if (yes) {
      await axios.put(`${SEL_API}/${selectionId}/notify`, { notify: true })
        .then(() => toast.success('Ti avviseremo su gol, esiti e riepilogo'))
        .catch(() => toast.error('Non riuscito: attivale con la campanella sulla selezione'));
    }
    onDone?.(yes);
  };

  return (
    <NotifyAskModal
      open={!!pushState}
      pushState={pushState}
      onAnswer={answer}
      title="Vuoi essere avvisato su questa selezione?"
      text="Una notifica per ogni gol, per l'esito di ogni partita e il riepilogo finale. Puoi cambiare idea con la campanella."
      yesLabel="Sì"
      noLabel="No"
      zClass="z-[9995]"
    />
  );
};
